// extracted by mini-css-extract-plugin
module.exports = {"root":"sixth_root__9izfq","check":"sixth_check__2856P"};